<template>
	<div
		class="g-block-body-dashed-title g-block-body-padding"
		:class="{
			'g-block-body-dashed-title--edit': editable,
			'is-active': editable && active,
			'g-block-body-dashed-title--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-dashed-title__shell">
			<div class="g-block-body-dashed-title__title-wrap">
				<div class="g-block-body-dashed-title__title-mask">
					<RichTextEditable
						v-if="editable"
						class="g-block-body-dashed-title__title"
						fit-content
						:style="{ color: themeColor }"
						:model-value="data.title"
						placeholder="请输入标题"
						@update:model-value="onTitleUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-body-dashed-title__title"
						:style="{ color: themeColor }"
						v-html="data.title || ''"
					></div>
				</div>
			</div>
			<div
				class="g-block-body-dashed-title__frame"
				:style="{ borderColor: themeColor }"
			>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-dashed-title__text"
					:model-value="data.content"
					placeholder="请输入正文"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-dashed-title__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyDashedTitle',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	@title-overlap: 11px;

	.g-block-body-dashed-title {
		.body-block-edit-shell();
	}

	.g-block-body-dashed-title__shell {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	.g-block-body-dashed-title__title-wrap {
		position: relative;
		z-index: 1;
		display: flex;
		justify-content: flex-start;
		padding-left: 12px;
		margin-bottom: -@title-overlap;
	}

	.g-block-body-dashed-title__title-mask {
		display: inline-flex;
		max-width: calc(100% - 24px);
		padding: 0 8px;
		background: #fff;
		line-height: 0;
	}

	.g-block-body-dashed-title__title {
		.body-title-base();
		font-size: 16px;
		font-weight: 700;
		line-height: 1.4;
		white-space: nowrap;
	}

	.g-block-body-dashed-title__frame {
		border: 1px dashed;
		border-radius: 4px;
		padding: calc(@title-overlap + 8px) 14px 14px;
		box-sizing: border-box;
	}

	.g-block-body-dashed-title__text {
		.body-text-base();
	}

	.g-block-body-dashed-title--h5 {
		@title-overlap-h5: 0.22rem;

		.g-block-body-dashed-title__title-wrap {
			padding-left: 0.24rem;
			margin-bottom: calc(-1 * @title-overlap-h5);
		}
		.g-block-body-dashed-title__title-mask {
			max-width: calc(100% - 0.48rem);
			padding: 0 0.16rem;
		}
		.g-block-body-dashed-title__title {
			font-size: 0.32rem;
		}
		.g-block-body-dashed-title__frame {
			border-radius: 0.08rem;
			padding: calc(@title-overlap-h5 + 0.16rem) 0.28rem 0.28rem;
		}
		.body-text-base--h5(~'.g-block-body-dashed-title__text');
	}
</style>
